// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__KtPZr","actionsCol":"EnrolledClinics_actionsCol__1LF20"};